import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SystemCalendarPage, ModalAddSystemCalendarRequestPage } from './systemCalendar';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    SystemCalendarPage,
    ModalAddSystemCalendarRequestPage,
  ],
  imports: [
    IonicPageModule.forChild(SystemCalendarPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalAddSystemCalendarRequestPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class SystemCalendarPageModule {}



// WEBPACK FOOTER //
// ./src/pages/systemCalendar/systemCalendar.module.ts